import { WidgetStrategyWithStreamByRequestUid } from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import {
    ObvTileConfigState,
    initialObvTileConfigState,
} from 'widgets/obvTile/store/config/ObvTileConfigState';
import { ObvTile } from 'widgets/obvTile/components/ObvTile';
import { obvTileWidgetStreamConfig } from 'widgets/obvTile/store/stream/stream-config';
import { obvTileDescription } from 'widgets/obvTile/components/description/obvTileDescription';
import { MyPortfolioCapsuleWidgetStrategyWithConfig } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { ObvTileStreamRequest } from 'widgets/obvTile/api/ObvTileStreamRequest';
import React from 'react';
import ObvTileSettings from 'widgets/obvTile/components/settings/ObvTileSettings';
import { ObvTileMyPortfolioCapsuleContent } from 'widgets/obvTile/components/ObvTileMyPortfolioCapsuleContent';
import { useObvMessagesInMyPortfolioCapsules } from 'widgets/obvTile/components/useObvMessagesInMyPortfolioCapsules';

const useMessagesInMyPortfolioCapsules = (symbol: string) =>
    useObvMessagesInMyPortfolioCapsules(symbol);

export const obvTileWidgetStrategy: MyPortfolioCapsuleWidgetStrategyWithConfig<ObvTileConfigState> &
    WidgetStrategyWithStreamByRequestUid<ObvTileStreamRequest> = {
    title: 'OBV',
    supportedHosts: ['tile'],
    reactComponentType: ObvTile,
    categories: [WidgetCategory.SIGNAL_CAPSULES],
    description: obvTileDescription,
    portfolioSelectionRequirements: PortfolioSelectionRequirements.None,
    initialConfigState: initialObvTileConfigState,
    managedStreamConfig: obvTileWidgetStreamConfig,
    supportsMyPortfolioCapsule: true,
    supportsMyPortfolioCapsuleConfig: true,
    myPortfolioCapsuleContentReactComponentType:
        ObvTileMyPortfolioCapsuleContent,
    renderSettingsBody,
    useMessagesInMyPortfolioCapsules,
};

function renderSettingsBody(
    config: ObvTileConfigState,
    onChange: (configDelta: Partial<ObvTileConfigState>) => void
) {
    return <ObvTileSettings config={config} onChange={onChange} />;
}
